exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  line-height: normal;\n}\nimg {\n  vertical-align: baseline;\n}\nbutton.btn-default {\n  color: black;\n}\n.modal {\n  background-color: #00000057;\n}\n", ""]);

// exports
